import { render } from "./ServicesForAE.vue?vue&type=template&id=6495f5ca"
import script from "./ServicesForAE.vue?vue&type=script&lang=js"
export * from "./ServicesForAE.vue?vue&type=script&lang=js"

import "./ServicesForAE.vue?vue&type=style&index=0&id=6495f5ca&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__